import { styled } from "styled-components";

import { useTranslate } from "common/utilities/useTranslate";
import { StyledLandingText } from "domains/landing/components/StyledLandingText";
import { StyledLandingTitle } from "domains/landing/components/StyledLandingTitle";

const StyledText = styled(StyledLandingText)`
  color: ${({ theme }) => theme.colors.textFade};
  margin-bottom: 5rem;
`;

type CreateLandingTitleProps = { mode?: "collection" | "map" };

export const CreateLandingTitle = ({ mode = "map" }: CreateLandingTitleProps) => {
  const translate = useTranslate();

  const title = mode === "map" ? "app.create.landing_banner.title" : "app.create.collection.landing_banner.title";
  const text = mode === "map" ? "app.create.landing_banner.text" : "app.create.collection.landing_banner.text";

  return (
    <>
      <StyledLandingTitle>{translate(title)}</StyledLandingTitle>
      <StyledText>{translate(text)}</StyledText>
    </>
  );
};
